import { MenuEntry } from '@src/menu-entry';

export default MenuEntry.create()
    .setRoute('printer')
    .setAdditionalRoutes([
        'printer_create',
        'printer_edit',
    ]);
